import {
  FETCH_FORUM_DETAILS,
  FETCH_COMMUNITYCATEGORY,
  SET_FORUM_DETAILS,
  SHOW_ONLY_COMMUNITY_DETAILS,
  FETCH_POST_COMMENT,
  SET_POST_COMMENT,
  SHOW_POST_COMMENT_MODAL,
  SET_POST,
  FETCH_POST_LIKE,
  CREATE_POST_MODAL,
  FETCH_NEW_MESSAGE,
  FETCH_OLD_MESSAGE,
  SELECTED_COMMUNITY_DETAILS,
  UNREAD_COMMUNITY_MESSAGE_COUNT
} from '../actions';

export function communityDetails(state = {}, action) {
  switch (action.type) {
    case FETCH_FORUM_DETAILS:
      return action.payload;
    default:
      return state;
  }
}
export function communityCategoriesReducer(state = [], action) {
  switch (action.type) {
    case FETCH_COMMUNITYCATEGORY:
      return action.payload;
    default:
      return state;
  }
}
export const setCommunityDetails = (state = null, action) => {
  switch (action.type) {
    case SET_FORUM_DETAILS:
      return action.payload;
    default:
      return state;
  }
};

export const showOnlyCommunityDetailsReducer = (state = false, action) => {
  switch (action.type) {
    case SHOW_ONLY_COMMUNITY_DETAILS:
      return action.payload;
    default:
      return state;
  }
};

export const postComment = (state = false, action) => {
  switch (action.type) {
    case FETCH_POST_COMMENT:
      return action.payload;
    default:
      return state;
  }
};

export const setPostCommentView = (state = false, action) => {
  switch (action.type) {
    case SET_POST_COMMENT:
      return action.payload;
    default:
      return state;
  }
};

export const postCommentModal = (state = false, action) => {
  switch (action.type) {
    case SHOW_POST_COMMENT_MODAL:
      return action.payload;
    default:
      return state;
  }
};

export const getPostDetails = (state = {}, action) => {
  switch (action.type) {
    case SET_POST:
      return action.payload;
    default:
      return state;
  }
};
export const postLikes = (state = false, action) => {
  switch (action.type) {
    case FETCH_POST_LIKE:
      return action.payload;
    default:
      return state;
  }
};

export const postCreateModalReducer = (state = { state: false }, action) => {
  switch (action.type) {
    case CREATE_POST_MODAL:
      return action.payload;
    default:
      return state;
  }
};

export const communityNewMessage = (state = false, action) => {
  switch (action.type) {
    case FETCH_NEW_MESSAGE:
      return action.payload;
    default:
      return state;
  }
};
export const communityOldMessage = (state = false, action) => {
  switch (action.type) {
    case FETCH_OLD_MESSAGE:
      return action.payload;
    default:
      return state;
  }
};

export const selectedCommunityDetails = (state = {}, action) => {
  if (action.type == SELECTED_COMMUNITY_DETAILS) {
    return action.payload;
  }
  return state;
};

export const unreadCommunityMessageCountReducer = (state = 0, action) => {
  if (action.type === UNREAD_COMMUNITY_MESSAGE_COUNT) return action.payload;
  return state;
};
